import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const FULLSCREEN_STORAGE_KEY =
  'games_fullscreen_enabled'

const PUBLIC_PATHS = [
  '/play/',
  '/p/',
]

const FullscreenManager = () => {
  const location = useLocation()

  useEffect(() => {
    const isPublicRoute =
      PUBLIC_PATHS.some((path) =>
        location.pathname.startsWith(path),
      )

    if (!isPublicRoute) {
      return undefined
    }

    const fullscreenEnabled =
      sessionStorage.getItem(
        FULLSCREEN_STORAGE_KEY,
      ) === 'true'

    if (!fullscreenEnabled) {
      return undefined
    }

    const requestFullscreen =
      async () => {
        if (
          document.fullscreenElement ||
          !document.documentElement
            .requestFullscreen
        ) {
          return
        }

        try {
          await document.documentElement
            .requestFullscreen()
        } catch (error) {
          /*
           * O navegador pode bloquear a entrada
           * automática. Nesse caso, a próxima
           * interação tentará novamente.
           */
        }
      }

    const handleInteraction = () => {
      requestFullscreen()
    }

    const handleFullscreenChange =
      () => {
        /*
         * Se o usuário sair com ESC, não é
         * possível forçar imediatamente.
         * A próxima interação tenta entrar
         * novamente.
         */
        if (!document.fullscreenElement) {
          document.addEventListener(
            'pointerdown',
            handleInteraction,
            {
              once: true,
            },
          )

          document.addEventListener(
            'keydown',
            handleInteraction,
            {
              once: true,
            },
          )
        }
      }

    requestFullscreen()

    if (!document.fullscreenElement) {
      document.addEventListener(
        'pointerdown',
        handleInteraction,
        {
          once: true,
        },
      )

      document.addEventListener(
        'keydown',
        handleInteraction,
        {
          once: true,
        },
      )
    }

    document.addEventListener(
      'fullscreenchange',
      handleFullscreenChange,
    )

    return () => {
      document.removeEventListener(
        'pointerdown',
        handleInteraction,
      )

      document.removeEventListener(
        'keydown',
        handleInteraction,
      )

      document.removeEventListener(
        'fullscreenchange',
        handleFullscreenChange,
      )
    }
  }, [location.pathname])

  return null
}

export default FullscreenManager